import styled from "@emotion/styled";

export const StyledCompany = styled.div`
  width: 100%;
  
  & * {
    font-family: Pretendard !important;
    font-display: swap;
  }
`;